/*
==============================
Contenidos detalle desplegable
==============================
*/
$(function() {
    var $contenidosDesplegables = $('.contenido-desplegable'),
        swipers = [],
        timer_resize;

    $.fn.extend({
        updateSwiper : function() {
            var swiperId = parseInt($(this).attr('data-swiper-id'), 10),
                slideToIndex = 0,
                slidesPerView = swipers[swiperId].params.slidesPerView,
                slidesNum = $('.contenidos-block > .bottom-block .swiper-slide').length,
                freeMode = swipers[swiperId].params.freeMode,
                centeredSlides = swipers[swiperId].params.centeredSlides;

            if (window.innerWidth > media.mobile) {
                if (slidesNum <= 2) {
                    slidesPerView = 2;
                    slideToIndex = (slidesNum == 2) ? 0.5 : 0;

                    centeredSlides = (slidesNum == 2) ? false : true;
                    freeMode = true;
                    swipers[swiperId].lockSwipes();
                }
                else {
                    slidesPerView = (window.innerWidth > media.tablet) ? 3 : 2;
                    slideToIndex = 1;

                    centeredSlides = true;
                    freeMode = false;

                    if (window.innerWidth > media.tablet) swipers[swiperId].lockSwipes();
                    else swipers[swiperId].unlockSwipes();
                }
            }
            // else if (window.innerWidth > media.mobile) {
            //     slidesPerView = 2;
            //     slideToIndex = $(this).find('.swiper-slide.active').index();

            //     freeMode = false;
            //     centeredSlides = true;
            //     swipers[swiperId].unlockSwipes();
            // }
            else {
                slideToIndex = $(this).find('.swiper-slide.active').index();

                freeMode = false;
                centeredSlides = true;
                swipers[swiperId].unlockSwipes();
            }

            swipers[swiperId].params.freeMode = freeMode;
            swipers[swiperId].params.centeredSlides = centeredSlides;
            swipers[swiperId].params.slidesPerView = slidesPerView;
            swipers[swiperId].update();
            swipers[swiperId].slideTo(slideToIndex);
        }
    });

    function checkAddContenidosDesplegablesSwiper() {
        $contenidosDesplegables.each(function(i) {
            var swiperCont = '#' + $(this).attr('id') + ' .swiper-container',
                $swiperWrapper = $(swiperCont).children('.swiper-wrapper');

            if ($swiperWrapper && $swiperWrapper.length > 0) {
                swipers[i] = new Swiper(swiperCont, {
                    spaceBetween: 0,
                    slidesPerView: 1.2,
                    preventClicksPropagation: false,
                    resistanceRatio: 0.5,
                    centeredSlides: true,
                    roundLengths: true,
                    initialSlide: $swiperWrapper.children('.active').index()
                });
                $(this).attr('data-swiper-id', i);
            }
        });
    }

    function checkHashURL() {
        var hash = window.location.hash;

        if (hash.length > 1 && hash.indexOf('contenido-desplegable-') > 0) {
            $(hash + ' .top-block a').trigger('click');
        }
        fixHeights.updateHeights();
    }

    function closeSwiper() {
        var $activeDesplegable = $('.contenido-desplegable.active'),
            $activeBottom = ($('.contenidos-block > .bottom-block').length ? $('.contenidos-block > .bottom-block') : $('.contenido-desplegable.active > .bottom-block'));

        if ($activeDesplegable.hasClass('active')) {
            $activeBottom.hide().promise().done(function() {
                if (window.innerWidth > media.mobile) {
                    $activeBottom.detach().appendTo($activeDesplegable);
                    if ($(window).scrollTop() != $activeDesplegable.offset().top - 10) {
                        $('html, body').animate({
                            scrollTop: $activeDesplegable.offset().top - 10
                        }, 'slow');
                    }
                }
                $activeDesplegable.removeClass('active');
            });
        }
    }

    if ($contenidosDesplegables.length > 0) {
        $('.contenido-desplegable .top-block a').on('click', function(e) {
            e.preventDefault();
            $(".contenidos-detalle-desplegable").find(".video-youtube.active iframe").remove();
            $(".contenidos-detalle-desplegable").find(".video-youtube.active .video-close").trigger("click");
            $(".contenidos-detalle-desplegable").find("a.swiper-close").show();
            var $desplegable = $(this).closest('.contenido-desplegable'),
                $activeDesplegable = $('.contenido-desplegable.active'),
                $activeBottom = ($('.contenidos-block > .bottom-block').length ? $('.contenidos-block > .bottom-block') : $('.contenido-desplegable.active > .bottom-block'));

            if (!$desplegable.hasClass('active')) {
                setHash('#' + $desplegable.attr('id'));
                $activeBottom.hide().promise().done(function() {
                    if (window.innerWidth > media.mobile) {
                        $activeBottom.detach().appendTo($activeDesplegable);
                        $desplegable.children('.bottom-block').detach().appendTo('.contenidos-block').show().promise().done(function() {
                            fixHeights.updateHeights();
                        });

                        if (window.innerWidth <= media.tablet || $desplegable.offset().top > $(document).scrollTop()) {
                            $('html, body').animate({
                                scrollTop: $('.contenido-desplegable').last().offset().top - 10
                            }, 'slow');
                        }
                    }
                    else {
                        $('html, body').animate({
                            scrollTop: $desplegable.offset().top - 10
                        }, 'slow');
                        $desplegable.children('.bottom-block').show().promise().done(function() {
                            fixHeights.updateHeights();
                        });
                    }
                    $activeDesplegable.removeClass('active');
                    $desplegable.addClass('active');
                    if (typeof $desplegable.data('swiper-id') !== "undefined") $desplegable.updateSwiper();
                });
            }
            else {
                closeSwiper();
                setHash('#');
            }
            fixHeights.updateHeights();
        });

        $(document).on('click', '.swiper-close', function(e) {
            e.preventDefault();

            closeSwiper();
        });

        $(window).on( 'hashchange', function(e) {
            e.preventDefault();
            checkHashURL();
        });
        // $(window).on('resize', function() {
        //     if (!isMobile.any()) {
        //         clearTimeout(timer_resize);
        //         timer_resize = setTimeout(closeSwiper, 150);
        //     }
        // }).on( 'hashchange', function(e) {
        //     e.preventDefault();
        //     checkHashURL();
        // });

        checkAddContenidosDesplegablesSwiper();
        checkHashURL();
    }

    $(".contenidos-detalle-desplegable").find(".video-link").on("click", function(){
        $(".contenidos-detalle-desplegable").find("a.swiper-close").hide(); 
    });

    $(".contenidos-detalle-desplegable").find(".video-close").on("click", function(){
        $(".contenidos-detalle-desplegable").find("a.swiper-close").show(); 
    });
});